import Data from 'react-k2-api/Api/Data'

/**
 * Predikční model - položky
 */
export default class TPredictionItemDM extends Data {
	public static className = 'TPredictionItemDM'
	public static systemFields = [
	]

	public static isHeader = true

	/**
	 * QuantityY
	 */
	QuantityY?: number

	/**
	 * ValueY
	 */
	ValueY?: number

	/**
	 * DateX
	 */
	DateX?: Date

	/**
	 * TimeSerie
	 */
	TimeSerie?: number

	/**
	 * PredictionModel
	 */
	PredictionModelRID?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Změna skupiny práv
	 */
	public ChangeGroupRightCOMMAND() {
		return this.executeCommand('ChangeGroupRightCOMMAND')
	}

	/**
	 * Změna skupiny práv
	 */
	public BulkChangeGroupRightCOMMAND() {
		return this.executeCommand('BulkChangeGroupRightCOMMAND')
	}

	/**
	 * Aktualizace počítaných polí
	 */
	public BulkUpdateCalcFieldsCOMMAND() {
		return this.executeCommand('BulkUpdateCalcFieldsCOMMAND')
	}

	/**
	 * Kontrola legislativy
	 */
	public SwitchOffLegislationValidationCOMMAND() {
		return this.executeCommand('SwitchOffLegislationValidationCOMMAND')
	}
}